// Lightweight signal the onboarding Widget listens for. Call this from
// anywhere a mutation lands that should re-tick an onboarding step (e.g.
// after createAutomation, createSection, inviteUser, publishCourse). The
// Widget refetches its counts in response — without this, in-place
// mutations stay invisible to the widget until the user navigates.
//
// Decoupled via a CustomEvent so the call site doesn't need to know
// anything about the Widget's internals or import its module.
export const COUNTS_CHANGED_EVENT = 'onark:onboarding-counts-changed';

export function signalCountsChanged() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(COUNTS_CHANGED_EVENT));
}
